@let sidebar = productViewLayout.sidebar;

<page-sidebar [class]="{'size-guide': (sidebar === 'size-guide'), 'icms-open': client.isCms}"
              [backArrow]="!client.isS && sidebar !== 'size-guide'"
              [closeButton]="sidebar === 'how-to-measure' || sidebar === 'size-guide'"
              [(isOpen)]="productViewLayout.isSidebarOpen"
              (isOpenChange)="handleIsOpenChange()"
              (closeRequest)="handleCloseRequest()">
    <product-reviews [class.ng-hide]="sidebar !== 'reviews'"
                     [product]="productViewLayout.parent().familyIds"
                     [productName]="product().data?.name"
                     [productData]="productViewLayout.parent" />
    <product-layout-details-general [class.ng-hide]="sidebar !== 'details'"
                                    [productViewLayout]="productViewLayout"
                                    [content]="content()" />
    <product-layout-details-general-dimensions [class.ng-hide]="sidebar !== 'dimensions'"
                                               [productViewLayout]="productViewLayout"
                                               [content]="content()" />
    <product-layout-gift-boxing [class.ng-hide]="sidebar !== 'gift-boxing'"
                                [content]="content()" />
    <product-delivery-price [class.ng-hide]="sidebar !== 'delivery'"
                            [productId]="product().id"
                            [content]="{
                                returnNote: content().returnNote,
                                returnLink: content().returnLink,
                                returnLinkText: content().returnLinkText
                            }" />
    <basket-klarna-content-block class="w-12"
                                 [class.ng-hide]="sidebar !== 'klarna'" />

    <bloomreach-stock-notification class="w-12"
                                   [class.ng-hide]="sidebar !== 'stock-notification'"
                                   [model]="product()" />
    @if (productViewLayout.sizeGuideVariant) {
    <product-layout-sidebar-size-guide [class.ng-hide]="sidebar !== 'size-guide'"
                                       [variant]="productViewLayout.sizeGuideVariant"
                                       [productViewLayout]="productViewLayout" />
    }
    <product-layout-sidebar-how-to-measure [class.ng-hide]="sidebar !== 'how-to-measure'"
                                           [variant]="productViewLayout.sizeGuideVariant" />
</page-sidebar>